export default {
  data: function data() {
    return {
      importable: false,
      importSubmitUrl: null,
      importParamName: "row"
    };
  },
  methods: {
    initCsvImport: function initCsvImport() {
      var vm = this;
      Utils.type.ifObject(this.spec["import"], function (obj) {
        vm.importable = true;
        vm.importSubmitUrl = obj.submitUrl;
        vm.importParamName = obj.paramName;
      });
    },
    submitRows: function submitRows(event, section) {
      var vm = this;
      var keys = section.header.dataCells;
      var rows = [];
      section.dataRows.forEach(function (row) {
        var cells = {};
        row.forEach(function (cell, index) {
          var key = "".concat(vm.importParamName, "[").concat(keys[index], "]");
          cells[key] = cell;
        });
        rows.push(cells);
      });

      if (Utils.type.isString(this.importSubmitUrl)) {
        vm._submitEachRow(rows, event.target);
      }
    },
    _submitEachRow: function _submitEachRow(rows, target) {
      var vm = this;
      var row = rows.shift();

      if (row) {
        var data = {
          url: this.importSubmitUrl,
          formData: row
        };
        Utils.http.execute(data, "POST", vm, function (response) {
          GLib.action.handleResponse(response, vm);

          vm._submitEachRow(rows, target);
        });
      }
    },
    loadFile: function loadFile(event, section) {
      var _this = this;

      var reader = new FileReader();
      reader.readAsText(event.target.files[0]);

      reader.onload = function (e) {
        var rows = _this._parseCsv(e.target.result);

        section.header.dataCells = rows.shift().map(function (cell) {
          return cell.trim();
        });
        section.dataRows = rows;
      }; // Reset value so it will trigger again the next time the same file is selected.


      event.target.value = null;
    },
    _parseCsv: function _parseCsv(csvString) {
      // https://stackoverflow.com/a/41563966/9970813
      var prevLetter = "",
          row = [""],
          result = [row],
          columnIndex = 0,
          rowIndex = 0,
          canSplit = true,
          letter;

      for (var i = 0; i <= csvString.length; ++i) {
        letter = csvString[i];

        if ('"' === letter) {
          if (canSplit && letter === prevLetter) {
            row[columnIndex] += letter;
          }

          canSplit = !canSplit;
        } else if ("," === letter && canSplit) {
          letter = row[++columnIndex] = "";
        } else if ("\n" === letter && canSplit) {
          if ("\r" === prevLetter) {
            row[columnIndex] = row[columnIndex].slice(0, -1);
          }

          row = result[++rowIndex] = [letter = ""];
          columnIndex = 0;
        } else if (Utils.type.isString(letter)) {
          row[columnIndex] += letter;
        }

        prevLetter = letter;
      } // Remove any blank rows


      result = result.filter(function (r) {
        return r[0] !== "";
      }); // result = result.filter(r => {
      //   return r[0] !== "undefined"
      // });

      return result;
    }
  }
};